import { px, rect, cRect, mRect, mPx, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_gunship: Hull = {
  id: 'hull_gunship',
  name: 'Gunship',
  drawBody: (ctx, p) => {
    const profile: [number, number][] = [
      [23,2],[24,3],[25,4],[26,5],[27,6],[28,7],[29,8],
      [30,8],[31,8],[32,8],[33,8],[34,8],[35,8],[36,7],
      [37,6],[38,6],[39,5],[40,5],[41,4],[42,4],
    ];
    profile.forEach(([y, hw]) => cRect(ctx, y, hw * 2, 1, p.primary));
    profile.forEach(([y, hw]) => { px(ctx, CENTER - hw, y, p.light); px(ctx, CENTER + hw - 1, y, p.shadow); });
    cRect(ctx, 37, 16, 1, p.shadow); cRect(ctx, 39, 12, 1, p.shadow); cRect(ctx, 42, 8, 2, p.dark);
    // Side armor plates
    mRect(ctx, 2, 30, 2, 6, p.accent);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 28 }, cap: (ctx, p) => { mPx(ctx, 3, 27, p.dark); mPx(ctx, 3, 28, p.dark); mPx(ctx, 3, 29, p.dark); cRect(ctx, 31, 6, 1, p.dark); } },
    [SLOT.WING_L]:     { anchor: { x: 22, y: 35 }, cap: (ctx, p) => { rect(ctx, 21, 34, 4, 3, p.shadow); rect(ctx, 21, 34, 4, 1, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 41, y: 35 }, cap: (ctx, p) => { rect(ctx, 39, 34, 4, 3, p.shadow); rect(ctx, 39, 34, 4, 1, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 28, y: 42 }, cap: (ctx, p) => { rect(ctx, 27, 41, 3, 2, p.shadow); rect(ctx, 27, 41, 3, 1, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 36, y: 42 }, cap: (ctx, p) => { rect(ctx, 34, 41, 3, 2, p.shadow); rect(ctx, 34, 41, 3, 1, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 26 }, base: (ctx, p) => { cRect(ctx, 27, 4, 2, p.metalDark); cRect(ctx, 27, 4, 1, p.metal); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 23 } },
  },
};
